export default "__VITE_ASSET__CyePdOFy__"